import React from 'react';

const LockIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
    <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const CheckIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const WorkshopModuleNav = ({ modules, activeModuleKey, activeLessonKey, completedLessons, isLessonLocked, onSelect }) => {
  const safeModules = Array.isArray(modules) ? modules : [];
  const safeCompleted = completedLessons instanceof Set ? completedLessons : new Set();
  const safeIsLocked = typeof isLessonLocked === 'function' ? isLessonLocked : () => false;

  return (
    <aside className="wk-modules-panel">
      <h2 className="wk-panel-title">Modules</h2>
      <div className="wk-module-list">
        {safeModules.map((module) => {
          const lessons = Array.isArray(module?.lessons) ? module.lessons : [];
          const moduleActive = module.key === activeModuleKey;
          return (
            <div key={module.key} className={`wk-module-card${moduleActive ? ' wk-module-card-active' : ''}`}>
              <button
                className="wk-module-btn"
                onClick={() => {
                  const firstUnlocked = lessons.find((l) => !safeIsLocked(module.key, l.key));
                  onSelect(module.key, firstUnlocked?.key || lessons[0]?.key || '');
                }}
              >
                {module.title}
              </button>

              <div className="wk-lesson-list">
                {lessons.map((lesson) => {
                  const lessonActive = module.key === activeModuleKey && lesson.key === activeLessonKey;
                  const locked = safeIsLocked(module.key, lesson.key);
                  const done = safeCompleted.has(lesson.key);
                  return (
                    <button
                      key={lesson.key}
                      className={[
                        'wk-lesson-item',
                        lessonActive ? 'wk-lesson-item-active' : '',
                        locked ? 'wk-lesson-item-locked' : '',
                        done && !locked ? 'wk-lesson-item-done' : '',
                      ].filter(Boolean).join(' ')}
                      onClick={() => onSelect(module.key, lesson.key)}
                      disabled={locked}
                      aria-disabled={locked}
                      title={locked ? 'Complete the previous lesson to unlock this one' : lesson.title}
                    >
                      <span className="wk-lesson-item-label">{lesson.title}</span>
                      {locked ? (
                        <span className="wk-lesson-status wk-lesson-status-lock"><LockIcon /></span>
                      ) : done ? (
                        <span className="wk-lesson-status wk-lesson-status-done"><CheckIcon /></span>
                      ) : null}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </aside>
  );
};

export default WorkshopModuleNav;